import $ from 'jquery';
import objectFitImages from 'object-fit-images';
import {Header} from "./Header";
import {Selector} from "./Cookies";
import {Sliders} from "./Sliders";
import {Counter} from "./Counter";

const header = new Header();
const carousel = new Sliders();


$(document).ready(function() {
  /* fix object-fit for IE */
  objectFitImages();

  /* animation header */
  header.animationHeader();

  /* run carousels */
  carousel.sliderBlocks();
  carousel.sliderTestimonials();
  carousel.sliderPloyee();

  /* run selector category */
  new Selector();
  new Counter();

});
